<template>
  <section class="payment-term-editor-compact">
    <header>{{ title }}</header>
    <article>
      <VFormItem>
        <VSelect
          class="payment-days-event"
          label="Условия оплаты"
          :layout="layout"
          placeholder="Выберите событие после которого оплатить"
          :options="paymentTermEventList"
          :clearable="false"
          required
          :disabled="disabled"
          :label-width="labelWidth"
          v-model="entity.paymentTerm.event"
          @update:modelValue="onPaymentTermInput('event', $event)"
        >
          <template #option="{ option }">
            {{ option.name }}
            <div class="description">
              {{ option.isPrepayment ? 'Предоплата' : 'Постоплата' }}
            </div>
          </template>
          <template #badge>
            {{ entity.paymentTerm.paymentTypeStringRepresentation }}
          </template>
        </VSelect>

        <VInputNumber
          class="payment-term-days"
          ref="paymentTermDays"
          label="Дней"
          :layout="layout"
          :precision="0"
          :min="1"
          required
          :disabled="isPaymentTermBeforeShipment || disabled"
          :title="disableReasonPaymentTermDaysInput"
          :validate-method="validatePaymentTermDays"
          v-model="entity.paymentTerm.days"
          @update:modelValue="onPaymentTermInput('days', $event)"
        />
      </VFormItem>
      <slot name="description" />
    </article>
  </section>
</template>

<style lang="scss" src="./PaymentTermEditorCompact.scss"/>

<script lang="ts">
import PaymentTerm         from '@/domains/PaymentTerms/PaymentTerm';
import PaymentTermEvent    from '@/domains/PaymentTerms/PaymentTermEvent';

import PaymentTermsService from '@/domains/PaymentTerms/PaymentTermsService';
import {UnwrapNestedRefs} from "vue";

export interface HasPaymentTerm {
  paymentTerm: PaymentTerm;
}
export default defineComponent({
  name: 'PaymentTermEditorCompact',

  props: {
    title: {
      type:    String,
      default: 'Оплата',
    },
    disabled: {
      type:    Boolean,
      default: false,
    },
    /** Сущность, содержащая paymentTerm: PaymentTerm */
    entity: {
      type:     Object as PropType<HasPaymentTerm | UnwrapNestedRefs<HasPaymentTerm>>,
      required: true,
    },
    layout: {
      type:    String,
      default: 'vertical',
    },
    labelWidth: {
      type:    String,
      default: null,
    },
  },

  computed: {
    paymentTermEventList(): PaymentTermEvent[] {
      return PaymentTermsService.getEventList();
    },

    isPaymentTermBeforeShipment(): boolean {
      return this.entity.paymentTerm?.event?.id === 'before_shipment';
    },

    disableReasonPaymentTermDaysInput(): string | null {
      if (this.isPaymentTermBeforeShipment) return 'При таких условиях оплаты ограничение 5 дней';
      return null;
    },

  },

  created() {
    if (!PaymentTerm.isPaymentTerm(this.entity.paymentTerm)) {
      throw TypeError('Условия оплаты должны иметь тип PaymentTerm');
    }
  },

  methods: {
    onPaymentTermInput(field: string, value: any): void {
      const newPaymentTerm  = this.$core.utils.cloneDeep(this.entity.paymentTerm);
      newPaymentTerm[field] = value;

      /** Нужно чтобы стриггерить сеттер в передаваемой сущности */
      this.entity.paymentTerm = newPaymentTerm;

      const paymentTermDaysInput = this.$refs.paymentTermDays as any;

      if (paymentTermDaysInput) {
        paymentTermDaysInput.validateForce();
      }
    },

    validatePaymentTermDays(): string | null {
      return this.entity.paymentTerm.validateDays();
    },
  },
});
</script>

